import type { PageTour } from '../types';

export const directoryTour: PageTour = {
  id: 'directory',
  label: 'Directory Tour',
  steps: [
    {
      target: '[data-tour="directory-header"]',
      title: 'People Directory',
      content: 'Find and connect with colleagues across your organization. Browse profiles and contact information.',
    },
    {
      target: '[data-tour="directory-search"]',
      title: 'Search People',
      content: 'Type a name, role, or department to quickly find someone in the directory.',
    },
    {
      target: '[data-tour="directory-filters"]',
      title: 'Filter by Team',
      content: 'Narrow down results by department, team, or location to find the right people.',
    },
    {
      target: '[data-tour="directory-list"]',
      title: 'People Cards',
      content: 'Each card shows a person\'s name, role, team, and contact details. Click to view their full profile.',
    },
  ],
};
